import { Asterisk, Copy } from "lucide-react";
import "./cards.scss";
import CardOpt from "../CardOpt/CardOptSection";
import { useEffect, useRef, useState } from "react";
import copy from "copy-to-clipboard";
import { useNotification } from "../../context/NotificationContext";
import AddCard from "../AddCard/AddCardSection";
import { usePrompt } from "../../context/PromptContext";
import { CardInput, PaymentCard } from "../../interface/interfaces";
import { addCard, deleteCardApi, loadCards, updateCard } from "../../api/requests";
import SkeletonLoader from "../SkeletonLoaders/DefaultLoader";
import EmptyDisplay from "../EmptyDisplay/EmptyDisplay";
import valid from 'card-validator';





const Cards = () => {
    const { notify } = useNotification();
    const { initPrompt } = usePrompt();
    const [toggleCardInput, setToggleCardInput] = useState(false);
    const [cardInput, setCardInput] = useState<CardInput>({
        id: "",
        firstname: "",
        lastname: "",
        card_number: "",
        cvv: "",
        expiry_date: "",
    });

    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [existingCards, setExistingCards] = useState<PaymentCard[]>([]);

    const [cardSelect, setCardSelect] = useState({
        id: '',
        menuToggle: false,
        isLoading: false
    })



    async function loadExisting() {
        try {
            let data = await loadCards()
            setExistingCards(data)
        } catch (error: any) {
            notify.error(error.message)
        }
    }

    useEffect(() => {
        const func = async () => {
            setIsLoading(true);
            await loadExisting()
            setIsLoading(false);
        };

        func();
        // eslint-disable-next-line
    }, []);

    const handleCopy = (text: string) => {
        const success = copy(text);

        if (success) {
            notify.success("Copied!");
        } else {
            notify.error("Failed to copy.");
        }
    };

    const discardFunc = () => {
        setCardInput({
            id: "",
            firstname: "",
            lastname: "",
            card_number: "",
            cvv: "",
            expiry_date: "",
        });

        setToggleCardInput(false);
    };

    const editCard = (card_id: string) => {

        let obj = existingCards.find((data) => {
            return data.id === card_id
        })

        if (obj) {

            const fullName = obj.card_owner;
            const [firstname, lastname] = fullName.split(" ");

            setCardInput({
                id: obj.id,
                firstname: firstname,
                lastname: lastname,
                card_number: obj.card_number,
                cvv: obj.card_cvv,
                expiry_date: obj.card_expiry,
            })

           setToggleCardInput(true);

        }
    };

    const deleteCard = async (card_id: string) => { 
         const callbackFunc = async () => {
        
                    try {
                        setIsLoading(true)
        
                        await deleteCardApi(card_id)
                        await loadExisting()
        
                        notify.success('Deleted card!')
        
                    } catch (error: any) {
                        notify.error(error.message)
                    } finally {
                        setIsLoading(false)
                    }
        
                }
        
                initPrompt('Delete Card', 'Do you want to delete this card?', callbackFunc)
    };

    const handleAddCard = () => {
        setCardInput({
            id: "",
            firstname: "",
            lastname: "",
            card_number: "",
            cvv: "",
            expiry_date: "",
        });

        setToggleCardInput(true);
    };

    const isAllInputValid = (data: CardInput) => {
        const requiredFields = [
            "firstname",
            "lastname",
            "card_number",
            "cvv",
            "expiry_date",
        ];

        return requiredFields.every((field) => {
            const value = (data as any)[field];
            return typeof value === "string" && value.trim() !== "";
        });
    };



    const saveFunc = async () => {
        try {
            setIsSaving(true);

            if (!isAllInputValid(cardInput)) {
                throw Error("Please fill in all required fields");
            }



            if (cardInput.id === "") {
                await addCard(cardInput)
            } else {
                await updateCard(cardInput,cardInput.id)
            }

            await loadExisting()

            if (cardInput.id === "") {
                notify.success("Added card succesfully!");
            } else {
                notify.success("Updated card info!");
            }

            discardFunc();
        } catch (error: any) {
            notify.error(error.message);
        } finally {
            setIsSaving(false);
        }
    };

    const createMenu = (id: string) => {
        setCardSelect((prev) => {
            return {
                ...prev,
                id: id,
                menuToggle: true
            }
        })
    };

    const cardInputBox = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggleCardInput &&
                cardInputBox.current &&
                !cardInputBox.current.contains(event.target as Node)
            ) {
                setToggleCardInput(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [toggleCardInput]);


    const handleMenuToggle = () => {

        setCardSelect((prev) => {
            return {
                ...prev,
                menuToggle: !prev.menuToggle
            }
        })

    }




    return (
        <div className="cards">
            <div className="cardhdr">
                <div className="title">Payment Option</div>

                <div className="btn" onClick={handleAddCard}>
                    Add Card
                </div>
            </div>


            {isLoading && (
                <SkeletonLoader count={4}></SkeletonLoader>
            )}

            {!isLoading && (

                <>
                    <div className="cardsGrid">
                        {existingCards.map((eachCard, idx) => {
                            const cardNum = (eachCard.card_number).trim() || "";
                            const last4 = cardNum.slice(-4);
                            const maskedLength = cardNum.length - 4;

                            const maskedGroups = Math.floor(maskedLength / 4);
                            const remaining = maskedLength % 4;

                            // Detect card type
                            const numberValidation = valid.number(cardNum);
                            const cardType = numberValidation.card?.type || 'default';

                            return (
                                <div className="paycard" key={idx}>
                                    <div className="cflex">
                                        <div></div>
                                        <div className="dotMenu" onClick={() => createMenu(eachCard.id)}>
                                            <div className="eachdot"></div>
                                            <div className="eachdot"></div>
                                            <div className="eachdot"></div>
                                        </div>

                                        {cardSelect.id === eachCard.id && (
                                            <CardOpt toggle={cardSelect.menuToggle} setToggle={handleMenuToggle} editFunc={() => editCard(eachCard.id)} deleteFunc={() => deleteCard(eachCard.id)}></CardOpt>
                                        )}



                                    </div>

                                    <div className="cardnumdiv">
                                        <div className="title">Card number</div>

                                        <div className="cardnum">
                                            {/* Render masked groups */}
                                            {Array(maskedGroups).fill(0).map((_, i) => (
                                                <div className="asteriskpack" key={i}>
                                                    {[...Array(4)].map((_, idx) => (
                                                        <Asterisk key={idx} size={12} />
                                                    ))}
                                                </div>
                                            ))}
                                            {/* Partial group */}
                                            {remaining > 0 && (
                                                <div className="asteriskpack">
                                                    {[...Array(remaining)].map((_, idx) => (
                                                        <Asterisk key={idx} size={12} />
                                                    ))}
                                                </div>
                                            )}

                                            {/* Last 4 digits */}
                                            <div className="lastnum">{last4}</div>

                                            <Copy
                                                size={19}
                                                className="copyicon"
                                                onClick={() => handleCopy(eachCard.card_number)}
                                            />
                                        </div>
                                    </div>

                                    <div className="carddet">
                                        <div className={`cardtype ${cardType}`}>
                                        </div>
                                        <div className="cardname">{eachCard.card_owner}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>


                    {existingCards.length <= 0 && (
                        <EmptyDisplay text={"No cards yet!"} icon_class={""}></EmptyDisplay>
                    )}
                </>

            )}



            <AddCard
                data={cardInput}
                isSaving={isSaving}
                toggle={toggleCardInput}
                setToggle={setToggleCardInput}
                saveFunc={saveFunc}
                setData={setCardInput}
                discardFunc={discardFunc}
            ></AddCard>
        </div>
    );
};

export default Cards;
